import axios from "axios";
import { authenticatedHeader } from "../../DefaultConfig";
import { AuthenticationURL } from "../../Services";
import { HideAwaiting, ShowAwaiting } from "../../../util/Awaiting";

export async function logout() {
    ShowAwaiting();
    await axios.post(AuthenticationURL + "/api/logout", {}, authenticatedHeader());
    HideAwaiting();
}